import { render, staticRenderFns } from "./CustomCpn.vue?vue&type=template&id=12c95772&scoped=true&"
import script from "./CustomCpn.vue?vue&type=script&lang=js&"
export * from "./CustomCpn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c95772",
  null
  
)

export default component.exports